<template>
    <div class="contrast-item">
        <!-- 1. 标题 -->
        <div class="contrast-item-title">
            <span class="name">{{source.fateInfo.name}}</span>
            <span class="sex">{{source.fateInfo.sex == '0' ? '男' : '女'}}</span>
        </div>
        <div class="contrast-item-fate-fortune-panel" v-bind:class="{'contrast-item-fate-fortune-no-fortune' : !contrastShowFortune}">
            <!-- 2. 命盘部分 -->
            <fate-panel
                v-bind:hideSideBar="false"
                v-bind:parentFrom="'contrast'"
                v-bind:fateData="source.fateListData"
                v-bind:fateSideData="source.fateSideListData"
                v-bind:fateInfo="source.fateInfo"
                v-bind:siZhuLiuNianReverse="parseInt(settingConfigData.sizhuGeShi) == 1"
                v-bind:sideCloseFunc="clickSideClose" >
            </fate-panel>
            <!-- 3. 运盘部分 -->
            <fortune-panel
                v-show="contrastShowFortune"
                v-bind:fateSideData="source.fateSideListData"
                v-bind:fortuneTitle="source.fortuneTitle"
                v-bind:fortuneData="source.fortuneListData"
                v-bind:transitioned="true"
                v-bind:parentFrom="'contrast'"
                v-bind:showType="source.showType"
                v-bind:showTable="source.showTable"
                v-bind:liunianData="source.liunianListData"
                v-bind:liuyueData="source.liuyueListData"
                v-bind:liuriData="source.liuriListData"
                v-bind:liushiData="source.liushiListData"
                v-bind:itemFunc="clickFortuneItem" >
            </fortune-panel>
        </div>
        <!-- 4. 删除遮罩 -->
        <div v-if="contrastShowItemDelete" class="contrast-item-delete" @click="clickDelete">
            <i class="iconfont icon-sub"></i>`
        </div>
    </div>
</template>

<script>
import FatePanel from '../../layouts/panel/FatePanel.vue'
import FortunePanel from '../../layouts/panel/FortunePanel.vue'
export default {
    name: 'ContrastItem',
    components: { FatePanel, FortunePanel },
    props: {
        source: {
            type: Object,
            default() { return {} }
        },
        itemIndex: {
            type: Number,
            default() { return -1 }
        }
    },
    computed: {
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        },
        contrastShowFortune() {
            return this.$store.state.contrast.contrastShowFortune;
        },
        contrastShowItemDelete() {
            return this.$store.state.contrast.contrastShowItemDelete;
        }
    },
    data() {
        return {
            clickLock: false,
        }
    },
    methods:{
        clickSideClose(data) {
            this.$store.dispatch("contrast/triggerContrastFateSideItemClose", {
                itemIndex: this.itemIndex,
                columnData: data
            });
            this.updateFortunePanel();
        },
        clickFortuneItem(data) {
            // 增加点击时间的锁定
            if(this.clickLock) { return; }
            setTimeout(() => { this.clickLock = false }, 300);
            this.clickLock = true;

            this.$store.dispatch("contrast/triggerContrastFortuneItemClick", {
                itemIndex: this.itemIndex,
                columnData: data
            });
            this.updateFortunePanel();
        },
        updateFortunePanel() {
            var liunian = document.getElementById('liunian'),
                liuyue = document.getElementById('liuyue'),
                liuri = document.getElementById('liuri'),
                liushi = document.getElementById('liushi');
            if(liunian) { liunian.style = ''; }
            if(liuyue) { liuyue.style = ''; }
            if(liuri) { liuri.style = ''; }
            if(liushi) { liushi.style = ''; }
        },
        clickDelete() {
            let contrastData = this.$store.state.contrast.contrastData;
            let bzArr = contrastData.bzid.split(',');
            console.log('clickDelete----', this.itemIndex, contrastData, bzArr)
            if(bzArr.length <= 2) {
                this.$toast("最少保留2个命盘");
                return;
            }
            this.$store.dispatch('contrast/updateContrast', {
                type: 'bzid_del',
                value: this.itemIndex,
            });
        }
    }
}
</script>
